import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';

const WithUnauthentication = (WrappedComponent, options = {}) =>
  class extends Component {
    static propTypes = {
      authenticated: PropTypes.bool.isRequired,
    };

    render() {
      const { authenticated } = this.props;

      const redirectUrl = options.redirectUrl || '/app';

      return !authenticated ? (
        <WrappedComponent {...this.props} />
      ) : (
        <Redirect to={redirectUrl} />
      );
    }
  };

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export { WithUnauthentication };

export default (WrappedComponent, options) => {
  return compose(connect(mapStateToProps), WithUnauthentication)(
    WrappedComponent,
    options,
  );
};
